/**
 * Upload nhiều ảnh — chọn file, danh sách đã chọn và xóa từng file.
 */
import { useId, useRef } from 'react';
import { TEXT } from '../../shared/languages';

export const ImageFileUpload = ({
  accept,
  hint,
  files = [],
  onFilesChange,
  disabled = false,
}) => {
  const inputId = useId();
  const inputRef = useRef(null);
  const form = TEXT.property.form;
  const fileCount = files.length;

  const handleChange = (event) => {
    onFilesChange(Array.from(event.target.files || []));
    event.target.value = '';
  };

  const handleChooseClick = () => {
    inputRef.current?.click();
  };

  const handleRemoveFile = (indexToRemove) => {
    onFilesChange(files.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className="image-file-upload">
      <input
        ref={inputRef}
        id={inputId}
        className="image-file-upload-input"
        type="file"
        accept={accept}
        multiple
        disabled={disabled}
        onChange={handleChange}
      />
      <div className="image-file-upload-toolbar">
        <button
          className="image-file-upload-button"
          type="button"
          disabled={disabled}
          onClick={handleChooseClick}
        >
          <span className="image-file-upload-button-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
              <path
                d="M12 16V8m0 0l-3 3m3-3l3 3M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          {form.imagesChoose}
        </button>
        <span className="image-file-upload-status">
          {fileCount
            ? form.imagesSelected.replace('{count}', String(fileCount))
            : form.imagesEmpty}
        </span>
      </div>
      {hint && <small className="field-hint">{hint}</small>}
      {!!fileCount && (
        <ul className="image-file-upload-list">
          {files.map((file, index) => (
            <li className="image-file-upload-item" key={`${file.name}-${file.lastModified}-${index}`}>
              <span className="image-file-upload-item-name" title={file.name}>
                {file.name}
              </span>
              <button
                className="image-file-upload-remove"
                type="button"
                disabled={disabled}
                onClick={() => handleRemoveFile(index)}
              >
                {form.imagesRemove}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
